import type { IInsightEntity } from '../types'

interface IApplyProducerFilterParams {
  items: IInsightEntity[]
  producer: string
}

const splitProducers = (raw: string): string[] =>
  raw
    .split(',')
    .map(name => name.trim())
    .filter(name => name.length > 0)

export const applyProducerFilter = ({
  items,
  producer,
}: IApplyProducerFilterParams): IInsightEntity[] => {
  const target = producer.trim()
  if (target === '') {
    return items
  }

  return items.filter(item => {
    if (item.producer === target) {
      return true
    }
    return splitProducers(item.producer).includes(target)
  })
}
